export class companyVisa {
    visa_id ?= '';
    company_id ?= '';
    company_name ?= '';
    permit_issue_date ?= '';
    permit_expiry_date ?= '';
    visa_issue_date ?= '';
    visa_expiry_date ?= '';
    arrival_date ?= '';
    visa_status_id ?= '';
    created_at ?= '';
}


// WEBPACK FOOTER //
// ./src/app/type/company-visa.ts